// id strings for messages/train.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const train: Dict = {
  "train.seo.title": "Latih Suara AI Kustom | Jammable",
  "train.seo.description":
    "Latih suara AI kustommu sendiri di Jammable. Unggah file audio, latih model suara, lalu bagikan ke komunitas atau simpan secara privat.",
  "train.h1": "Latih suara",
  "train.sub":
    "Masukkan beberapa menit nyanyian atau bicara yang jernih, dapatkan suara yang bisa kamu pakai di cover-mu.",
  "train.voicesTrained": "{count} suara sudah dilatih",

  "train.faq.title": "Pertanyaan umum",
  "train.faq.dataset.q": "Apa itu dataset?",
  "train.faq.dataset.a1": "Kumpulan file audio yang berisi vokal.",
  "train.faq.dataset.a2":
    "Minimal {min} menit nyanyian atau bicara, sebaiknya 10+ menit.",
  "train.faq.dataset.a3": "Format MP3, WAV atau M4A.",
  "train.faq.private.q": "Apakah suara kustomku akan privat?",
  "train.faq.private.a":
    "Ya! Kalau kamu memilih privat, hanya kamu yang bisa mengakses, melihat, dan memakai model suara kustommu!",
  "train.faq.time.q": "Berapa lama suaraku dilatih?",
  "train.faq.time.a":
    "Tergantung berapa banyak audio yang kamu tambahkan: biasanya {short} untuk 10 menit audio, {long} untuk satu jam audio. Kamu boleh menutup halaman ini; kami akan kirim email saat suaranya siap.",

  "train.eta.minutes": "sekitar {m} menit",
  "train.eta.hour": "sekitar {h} jam",
  "train.eta.hours": "sekitar {h} jam",
  "train.eta.hourMinutes": "sekitar {h} jam {m} menit",
  "train.eta.hoursMinutes": "sekitar {h} jam {m} menit",
  "train.minutes": "{n} menit",

  "train.samples": "Sampel",
  "train.filesOne": "1 file · {time}",
  "train.filesMany": "{n} file · {time}",
  "train.passesLeft": "Sisa jatah latih",
  "train.unlimited": "Tanpa batas",
  "train.nameIt": "Beri nama",
  "train.creatorShort": "Fitur latih suara sudah termasuk di Creator.",

  "train.upload.invalidType": "Jenis file tidak valid.",
  "train.upload.skippedOne":
    "{names} dilewati: sudah ditambahkan. Audio yang sama dua kali tidak membantu suaramu, jadi hanya dihitung sekali.",
  "train.upload.skippedMany":
    "{names} dilewati: sudah ditambahkan. Audio yang sama dua kali tidak membantu suaramu, jadi hanya dihitung sekali.",
  "train.upload.nFiles": "{n} file",
  "train.upload.someInvalid": "Satu atau beberapa file tidak valid.",
  "train.upload.failed": "Unggahan gagal",
  "train.upload.needsPlan": "Perlu paket untuk mengunggah",
  "train.upload.tooManyLabel":
    "Terlalu banyak unggahan saat ini, coba lagi sebentar lagi",
  "train.upload.tooManyToast":
    "Terlalu banyak unggahan saat ini. Coba lagi dalam beberapa menit.",
  "train.upload.analysing":
    "Masih mencari bagian hening di file-filemu. Tunggu sebentar.",
  "train.upload.blocked":
    "Beberapa file diblokir. Hapus file tersebut untuk melanjutkan.",
  "train.upload.errored":
    "Beberapa file bermasalah. Hapus file tersebut untuk melanjutkan.",
  "train.upload.processing":
    "Beberapa file masih diproses. Tunggu sampai selesai, ya.",
  "train.upload.tooShort":
    "Kamu butuh {min} nyanyian atau bicara, tanpa bagian hening. Punyamu baru {have}.",
  "train.upload.tooLong":
    "Maksimal {max} audio. Punyamu {have}: hapus satu file atau potong sebagian.",
  "train.upload.title": "Tambahkan suaramu",
  "train.upload.ofMin": "dari {min}",
  "train.upload.overLimit": "{over} melebihi batas {n} menit",
  "train.upload.ready": "Siap ✓",
  "train.upload.addMore": "Tambah {left} lagi",
  "train.upload.short":
    "Suara biasanya terdengar lebih bagus dengan {n}+ menit. Kamu bisa latih sekarang, atau tambah {left} lagi kalau punya.",
  "train.upload.uploadFiles": "Unggah file",
  "train.upload.record": "Rekam",
  "train.upload.addIt": "Tambahkan",
  "train.upload.recordHint":
    "Bernyanyi atau bicara. Rekam sebanyak yang kamu mau.",
  "train.upload.blockedFrom": "Diblokir - konten dari {label}",
  "train.upload.gettingReady": "Sedang disiapkan...",
  "train.upload.ofVoice": "{time} suara",
  "train.upload.removed": "{time} dihapus",
  "train.upload.uploading": "mengunggah...",
  "train.upload.done": "Selesai",
  "train.upload.trim": "Potong",
  "train.upload.retry": "Coba lagi",
  "train.upload.remove": "Hapus {name}",
  "train.upload.silenceNote":
    "Bagian hening dihapus otomatis. Yang ungu adalah bagian yang dipelajari suaramu.",
  "train.upload.tip1.title": "Satu suara saja",
  "train.upload.tip1.sub": "Tanpa backing vocal atau suara keramaian",
  "train.upload.tip2.title": "Ruangan yang tenang",
  "train.upload.tip2.sub": "Tanpa gema, tanpa suara latar",
  "train.upload.tip3.title": "Makin banyak makin bagus",
  "train.upload.tip3.sub": "Nada dan kata yang beragam",
  "train.upload.nextHint":
    "Berikutnya: nama, gambar, dan siapa yang bisa memakainya.",
  "train.upload.cardTitle": "Sampelmu",
  "train.upload.footnote":
    "Minimal {min} nyanyian atau bicara ({rec}+ lebih bagus), maksimal {max}. Bagian hening dan file yang berulang tidak dihitung; bagian hening dipotong otomatis.",
  "train.upload.footnoteNoRec":
    "Minimal {min} nyanyian atau bicara, maksimal {max}. Bagian hening dan file yang berulang tidak dihitung; bagian hening dipotong otomatis.",
  "train.upload.creatorNote":
    "Fitur latih suara sudah termasuk di Creator. Unggah vokalmu dulu dan putuskan di akhir; kamu akan melihat harganya sebelum membayar.",
  "train.upload.continue": "Lanjut",

  "train.sample.play": "Putar {label}",
  "train.sample.pause": "Jeda {label}",
  "train.clip.keptOf": "disimpan dari {total}",
  "train.clip.silenceCut": "{time} hening dipotong",
  "train.clip.cutByYou": "{time} kamu potong",
  "train.clip.cut": "dipotong",
  "train.clip.play": "Putar",
  "train.clip.stop": "Stop",
  "train.clip.keepIt": "Simpan",
  "train.clip.cutIt": "Potong",
  "train.clip.cancel": "Batal",
  "train.clip.hint":
    "Seret di bagian yang tidak kamu mau, lalu potong. Ketuk untuk mendengarkan.",
  "train.clip.undo": "Batalkan potonganku",

  "train.info.samplesAdded": "Sampel ditambahkan",
  "train.info.edit": "Edit",
  "train.info.namePlaceholder": "Nama suara, mis. Suaraku",
  "train.info.descPlaceholder":
    "Deskripsi - ceritakan ke komunitas bagaimana suara ini dilatih...",
  "train.info.whoCanUse": "Siapa yang bisa memakai",
  "train.info.private": "Privat, cuma aku",
  "train.info.public": "Publik di library",
  "train.info.cleanUp": "Bersihkan sampel",
  "train.info.removeInstrumentals": "Hapus instrumen",
  "train.info.removeInstrumentalsSub":
    "Membersihkan data input dari bagian non-vokal di dataset.",
  "train.info.removeReverb": "Hapus reverb",
  "train.info.removeReverbSub":
    "Membersihkan reverb dari semua audio di dataset.",
  "train.info.cardTitle": "Siap dilatih",
  "train.info.usuallyReadyIn": "Biasanya siap dalam",
  "train.info.upTo2h": "Hingga 2 jam",
  "train.info.closePage":
    "Pelatihan berjalan di server kami, jadi kamu boleh menutup halaman ini.",
  "train.info.starting": "Memulai...",
  "train.info.start": "Mulai melatih",
  "train.info.orGetPass": "Atau beli jatah latih",
  "train.info.getMorePasses": "Beli jatah latih tambahan",
  "train.info.usesOnePass": "Memakai 1 jatah latih",
  "train.info.started": "Pelatihan Dimulai",
  "train.info.onCreator": "Kamu sudah pakai Creator. Memulai pelatihanmu...",
  "train.info.legal":
    "Dengan melanjutkan, kamu memberi Jammable hak untuk memakai konten yang kamu unggah dan MENGONFIRMASI BAHWA KONTEN INI MILIKMU DAN TIDAK MENGANDUNG MATERI BERHAK CIPTA MILIK PIHAK KETIGA.",
  "train.info.agreeTerms": "Setujui Ketentuan Penggunaan kami dulu!",
  "train.info.chooseName": "Pilih nama suara dulu!",
  "train.info.uploadImage": "Unggah gambar dulu!",
  "train.info.invalidName": "Nama model tidak valid. Tanpa karakter khusus",
  "train.info.signIn": "Pengguna harus masuk dulu",
  "train.info.errorStarting": "Gagal memulai pelatihan",
  "train.info.errorSignedUrl": "Gagal mendapatkan signed URL",

  "train.demo.title": "Dengarkan suara yang sudah dilatih",
  "train.demo.by": "Oleh Power User Jammable",
  "train.demo.data.label": "Data latih",
  "train.demo.data.note": "Beberapa menit sebuah suara",
  "train.demo.input.label": "Lagu input",
  "train.demo.input.note": "Lagu yang akan dinyanyikan",
  "train.demo.output.label": "Hasil akhir",
  "train.demo.output.note": "Dinyanyikan dengan suara yang dilatih",
  "train.demo.play": "Putar {label}",
  "train.demo.pause": "Jeda {label}",

  "train.retry.trainAgain": "Latih lagi",
  "train.retry.tryAgain": "Coba lagi",
  "train.retry.orNewSamples": "Atau latih dengan sampel baru",
  "train.retry.retrying":
    "Sedang dilatih lagi. Kami akan kirim email saat suaranya siap.",
  "train.retry.couldntStart": "Pelatihan gagal dimulai. Coba lagi.",
  "train.retry.confirmUnlimited":
    "Kami akan melatihnya lagi dengan sampel yang sama. Sudah termasuk di paketmu.",
  "train.retry.confirmOutCreator":
    "Mencoba lagi memakai satu jatah latih, dan jatahmu sudah habis. Fitur latih suara sudah termasuk di Creator.",
  "train.retry.confirmOut":
    "Mencoba lagi memakai satu jatah latih, dan jatahmu sudah habis.",
  "train.retry.confirmPass":
    "Kami akan melatihnya lagi dengan sampel yang sama. Memakai 1 jatah latih (kamu punya {passes}); kalau gagal lagi, jatahnya dikembalikan.",
  "train.retry.cancel": "Batal",
  "train.retry.seeCreator": "Lihat Creator",
  "train.retry.getPass": "Beli jatah latih",
  "train.retry.orGetPass": "Atau beli jatah latih",
  "train.retry.starting": "Memulai...",
  "train.retry.usePass": "Pakai satu jatah dan coba lagi",
  "train.retry.refuse.cleanVocals":
    "Kalau dicoba lagi, hasilnya akan gagal dengan cara yang sama. Latih lagi dengan vokal yang bersih: tanpa musik, tanpa jeda hening yang panjang.",
  "train.retry.refuse.formats":
    "Kalau dicoba lagi, hasilnya akan gagal dengan cara yang sama. Latih lagi dengan file MP3, WAV atau M4A berisi nyanyian atau bicara yang jelas.",
  "train.retry.refuse.newSamples":
    "Kalau dicoba lagi, hasilnya akan gagal dengan cara yang sama. Latih lagi dengan sampel baru.",
  "train.retry.refuse.saveAs":
    "Kalau dicoba lagi, hasilnya akan gagal dengan cara yang sama. Simpan sebagai MP3 atau WAV lalu latih lagi.",
  "train.retry.refuse.filesMissing": "Latih lagi dengan sampel baru.",
  "train.retry.refuse.retryCap":
    "Suara ini sudah dicoba {n} kali. Latih lagi, sebaiknya dengan sampel yang berbeda.",

  "train.final.confirm": "Konfirmasi",
  "train.final.back": "Kembali",
  "train.final.next": "Berikutnya",
};

export default train;
